import { supabase } from "supabase";

export default async function createStatusHistory({ insertedProfiles, userName }) {
  const statusHistoryRecords = insertedProfiles.map((profile) => ({
    influencer_id: profile.id,
    assigned_member: userName || "System",
    status: "Pending",
  }));

  const { data: historyData, error: historyError } = await supabase
    .from("status_history")
    .insert(statusHistoryRecords)
    .select();

  if (historyError) {
    console.error("Failed to create initial status history:", historyError);
    return;
  }

  if (historyData) {
    insertedProfiles.forEach((profile) => {
      profile.status_history = historyData.filter((h) => h.influencer_id === profile.id);
    });
  }
}

